import { createFragment } from "../utilities/elements.js";
import { defineElement } from "./registry.js";
import { DickTokStandaloneComponent } from "./StandaloneComponent.js";

export class DickTokApp extends DickTokStandaloneComponent {
  static template = createFragment`
    <div>
        <slot></slot>
    </div>
    `;

  connectedCallback() {
    super.connectedCallback();
    this.#setupScrollRestoration();
  }

  #setupScrollRestoration() {
    history.scrollRestoration = "manual";
  }
}

defineElement("dt-app", DickTokApp);
